import { useMemo } from "react";
import useHandleSubmit from "../../../../../../hooks/common/searchers/submit/useHandleSubmit.js";
import useHasErrors from "../../../../../../hooks/common/searchers/useHasErrors.js";
import { useSearcherFlightHotelState } from "../../context/index.js";
const useButton = (buttonProps)=>{
    const state = useSearcherFlightHotelState();
    const { isLoading  } = state ?? {};
    const hasErrors = useHasErrors();
    const handleSubmit = useHandleSubmit();
    return useMemo(()=>({
            onClick: handleSubmit,
            disabled: hasErrors || !!isLoading,
            ...buttonProps
        }), [
        buttonProps,
        handleSubmit,
        hasErrors,
        isLoading
    ]);
};
export default useButton;

//# sourceMappingURL=useButton.js.map